import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DxDateRangeBoxModule, DxSelectBoxModule} from 'devextreme-angular';

export type OutboundMyScoreFilters = { from: Date; to: Date; fromHour: number; toHour: number };

@Component({
    selector: 'app-outbound-my-score-filter-bar',
    imports: [DxDateRangeBoxModule, DxSelectBoxModule],
    templateUrl: './outbound-my-score-filter-bar.component.html',
})
export class OutboundMyScoreFilterBarComponent implements OnInit {
    @Input() title = '';

    @Output() filtersChanged = new EventEmitter<OutboundMyScoreFilters>();

    protected dateRange: [Date, Date] = [new Date(), new Date()];
    protected fromHour = 0;
    protected toHour = 24;

    protected fromHourOptions = Array.from({length: 24}, (_, h) => ({value: h, text: OutboundMyScoreFilterBarComponent.formatHour(h)}));
    protected toHourOptions = Array.from({length: 24}, (_, h) => ({value: h + 1, text: OutboundMyScoreFilterBarComponent.formatHour(h + 1)}));

    private static formatHour(hour: number): string {
        const normalized = hour % 24;
        const suffix = normalized < 12 ? 'AM' : 'PM';
        const display = normalized % 12 === 0 ? 12 : normalized % 12;
        return `${display} ${suffix}`;
    }

    ngOnInit(): void {
        this.emitFilters();
    }

    protected onFiltersChanged(): void {
        this.emitFilters();
    }

    private emitFilters(): void {
        const [from, to] = this.dateRange;
        if (!from || !to) return;

        this.filtersChanged.emit({from, to, fromHour: this.fromHour, toHour: this.toHour});
    }
}
